import { z } from 'zod'

import { NameSchema, OrganizationTypeSchema } from '@mntn-dev/domain-types'
import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { Permissions } from './types/permissions.ts'

export const PermissionsSchema = z.array(z.enum(Permissions))

export const [PrivilegeKeys, PrivilegeKeySchema, PrivilegeKeyEnum] =
  EnumBuilder(
    'core',
    'organization-admin',
    'brand',
    'agency',
    'internal',
    'all'
  )
export type PrivilegeKey = ZodInfer<typeof PrivilegeKeySchema>

export const PrivilegeModelSchema = z.object({
  name: NameSchema,
  key: PrivilegeKeySchema,
  permissions: PermissionsSchema,
})

export type PrivilegeModel = ZodInfer<typeof PrivilegeModelSchema>

export const [RoleKeys, RoleKeySchema, RoleKeyEnum] = EnumBuilder(
  'brand',
  'organization-admin',
  'agency',
  'internal',
  'system'
)

export type RoleKey = ZodInfer<typeof RoleKeySchema>

export const RoleModelSchema = z.object({
  name: NameSchema,
  key: RoleKeySchema,
  privileges: z.array(PrivilegeKeySchema),
  organizationTypes: OrganizationTypeSchema.array(),
})

export type RoleModel = ZodInfer<typeof RoleModelSchema>
